import {
  GET_ALL_PROVINCIAS,
  GET_ALL_SERVICIOS,
  GET_ALL_SUCURSALES,
  GET_ALL_TIPOS_CONVENIOS,
  GET_ALL_CONVENIOS,
  GET_ALL_CANTONES,
  GET_ALL_CANTONES_ERROR,
  GET_ALL_DISTRITOS,
  GET_ALL_DISTRITOS_ERROR,
  GET_BIENES_SEARCH,
  GET_BIENES_SEARCH_ERROR,
  GET_TIPOS_BIEN,
  GET_TIPOS_BIEN_ERROR,
  GET_ALL_CONVENIOS_TILES,
  GET_ALL_CONVENIOS_TILES_ERROR,
} from "./types";
import BaseService from "app/@Base/services/base.service";

export function getServicios(token) {
  return function (dispatch) {
    try {
      return BaseService.reqAllServicios(token).then((data) => {
        dispatch({
          type: GET_ALL_SERVICIOS,
          payload: data.Items,
        });
      });
    } catch (error) {
      //   return (dispatch) => {
      //     dispatch({
      //       type: GET_ALL_SERVICIOS_ERROR,
      //     });
      //   };
    }
  };
}

export function getProvincias(token) {
  return function (dispatch) {
    try {
      return BaseService.reqAllProvincias(token).then((data) => {
        dispatch({
          type: GET_ALL_PROVINCIAS,
          payload: data.Items,
        });
      });
    } catch (error) {
      //   return (dispatch) => {
      //     dispatch({
      //       type: GET_ALL_PROVINCIAS_ERROR,
      //     });
      //   };
    }
  };
}

export function getSucursales(token) {
  return function (dispatch) {
    try {
      return BaseService.reqAllSucursales(token).then((data) => {
        dispatch({
          type: GET_ALL_SUCURSALES,
          payload: data.items,
        });
      });
    } catch (error) {
      //   return (dispatch) => {
      //     dispatch({
      //       type: GET_ALL_SUCURSALES_ERROR,
      //     });
      //   };
    }
  };
}

export function getCantones(token) {
  return function (dispatch) {
    try {
      return BaseService.reqAllCantones(token).then((data) => {
        dispatch({
          type: GET_ALL_CANTONES,
          payload: data,
        });
      });
    } catch (error) {
      return (dispatch) => {
        dispatch({
          type: GET_ALL_CANTONES_ERROR,
        });
      };
    }
  };
}

export function getDistritos(token) {
  return function (dispatch) {
    try {
      return BaseService.reqAllDistritos(token).then((data) => {
        dispatch({
          type: GET_ALL_DISTRITOS,
          payload: data,
        });
      });
    } catch (error) {
      return (dispatch) => {
        dispatch({
          type: GET_ALL_DISTRITOS_ERROR,
        });
      };
    }
  };
}

export function getTiposConvenios(token) {
  return function (dispatch) {
    try {
      return BaseService.reqAllTiposConvenios(token).then((data) => {
        dispatch({
          type: GET_ALL_TIPOS_CONVENIOS,
          payload: data.items,
        });
      });
    } catch (error) {}
  };
}

export function getConvenios(token) {
  return function (dispatch) {
    try {
      return BaseService.reqAllConvenios(token).then((data) => {
        dispatch({
          type: GET_ALL_CONVENIOS,
          payload: data.items,
        });
      });
    } catch (error) {}
  };
}

export function getBienesSearch(params, token) {
  return function (dispatch) {
    try {
      return BaseService.reqBienesSearch(params, token).then((data) => {
        dispatch({
          type: GET_BIENES_SEARCH,
          payload: data.items,
        });
      });
    } catch (error) {
      return (dispatch) => {
        dispatch({
          type: GET_BIENES_SEARCH_ERROR,
        });
      };
    }
  };
}

export function getTiposBien(token) {
  return function (dispatch) {
    try {
      return BaseService.reqTipoBien(token).then((data) => {
        dispatch({
          type: GET_TIPOS_BIEN,
          payload: data.Items,
        });
      });
    } catch (error) {
      return (dispatch) => {
        dispatch({
          type: GET_TIPOS_BIEN_ERROR,
        });
      };
    }
  };
}

export function getConveniosTiles(token) {
  return function (dispatch) {
    try {
      return BaseService.reqConveniosTiles(token).then((data) => {
        dispatch({
          type: GET_ALL_CONVENIOS_TILES,
          payload: data.items,
        });
      });
    } catch (error) {
      return (dispatch) => {
        dispatch({
          type: GET_ALL_CONVENIOS_TILES_ERROR,
        });
      };
    }
  };
}
